import api from '@/lib/api'
import { saveUserSessionSnapshot, useAuthState } from '../state/auth'
import { AuthAPI } from '@/types/auth'
import convertAuthClient from '../helpers/convertAuthClient'
import { isAxiosError } from 'axios'

export default function useSignInClient() {
  const [authState, setAuthState] = useAuthState()

  const signInClient = async (cpfProprietario: string, password: string) => {
    try {
      const response = await api.post<AuthAPI>('/auth/login-client', { cpfProprietario, password })
      const authResponse = convertAuthClient(response.data)

      // Preserve the internal user session so the portal login does not permanently replace it.
      saveUserSessionSnapshot(authState)
      setAuthState(authResponse)

      return authResponse.client
    } catch (error) {
      console.error('Login error:', error)
      let message = 'Erro no servidor'
      if (isAxiosError(error) && error.response?.status === 401) {
        message = 'Credenciais inválidas'
      }
      throw new Error(`Erro ao fazer login: ${message}`)
    }
  }

  return { signInClient }
}
